import ImagePreloader from 'image-preloader';

export default async function preloadImage(url: string): Promise<void> {
  if (!url?.length) {
    return;
  }
  try {
    await ImagePreloader.simplePreload(url);
  } catch (e) {
    console.warn('Image preload failed', url, e);
  }
}
